module.exports = __webpack_public_path__ + "img/gift.99131cfb.png";